import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { Baseurl } from '../../config/BaseUrl'
import axios from 'axios'
import { useDispatch, useSelector } from 'react-redux'
import { CaseActions, sendVehicleNumber } from '../../redux/Cases/CaseSlice'

const EditReport = () => {
    const { vehicleInfo } = useSelector((store) => store.cases)
    const params = useParams()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [assetType, setAssetType] = useState('')
    const [caseType, setCaseType] = useState('')
    const [valuationPurpose, setValuationPurposeType] = useState('Assesment of fair market value')
    const [requesterName, setRequesterName] = useState("");
    const [requesterNameError, setRequesterNameError] = useState("");
    const [requesterBranch, setRequesterBranch] = useState("");
    const [requesterBranchError, setRequesterBranchError] = useState("");
    const [requesterPhone, setRequesterPhone] = useState("");
    const [requesterPhoneError, setRequesterPhoneError] = useState("");
    const [name, setName] = useState('')
    const [mobileNo, setMobileNo] = useState('')
    const [email, setEmail] = useState('')
    const [address, setAddress] = useState('')
    const [state, setState] = useState('')
    const [city, setCity] = useState('')
    const [vehicleLocation, setVehicleLocation] = useState('')
    const [vehicleRegdNo, setVehicleRegdNo] = useState('')
    const [make, setMake] = useState('')
    const [model, setModel] = useState('')
    const [variant, setVariant] = useState('')
    const [vehicleData, setVehicleData] = useState({});
    const [dataFetched, setDataFetched] = useState(false)

    const handleRequesterPhn = async (e) => {
        const value = e.target.value.replace(/\D/g, "");
        setRequesterPhone(value)
    }
    useEffect(() => {
        const caseId = params.id;
        const fetchData = async () => {
            const url = `${Baseurl}/api/v1/cases/individualcase/${caseId}`;
            const caseFetch = await axios.get(url);
            const data = caseFetch.data.case
            console.log(data, "data");
            dispatch(CaseActions.setCurrCase(caseFetch.data.case))
            setAssetType(data.assetType)
            setCaseType(data.caseType)
            setValuationPurposeType(data.valuationPurpose)
            setRequesterName(data.requesterName)
            setRequesterPhone(data.requesterBranch)
            setRequesterBranch(data.requesterPhone)
            setName(data.name)
            setMobileNo(data.mobile)
            setEmail(data.email)
            setAddress(data.address)
            setState(data.state)
            setCity(data.city);
            setVehicleLocation(data.vehicleLocation);
            setVehicleRegdNo(data.regdNo);
            setMake(data.brand);
            setModel(data.model);
            setVariant(data.variant);
        }
        fetchData()
    }, [params.id])


    console.log(vehicleInfo, "vehicleInfo");

    // useEffect(() => {
    //     if (vehicleRegdNo.length === 9 || vehicleRegdNo.length === 10) {

    //         const getData = async () => {
    //             const vehicleNo = vehicleRegdNo.toLocaleUpperCase()
    //             let data = JSON.stringify({
    //                 "vehicleNumber": vehicleNo
    //             });
    //             let config = {
    //                 method: 'post',
    //                 maxBodyLength: Infinity,
    //                 url: 'https://api.invincibleocean.com/invincible/vehicleRcV6',
    //                 headers: {
    //                     'Content-Type': 'application/json',
    //                     'clientId': '7383c6f956c453a5689f4da6843b9f54:a3c36d6f8cc8dcf5ad904e5ab22150a0',
    //                     'secretKey': 'fvCtpjNbHpAVgoJiZJZPWNIjLsJO3VYqem6PsrENWSv54TYqehEomZCUtIwwegRT9'
    //                 },
    //                 data: data
    //             };
    //             axios.request(config)
    //                 .then((response) => {

    //                     setVehicleData(response.data.result.data)
    //                 })
    //                 .catch((error) => {
    //                 });
    //         }
    //         getData()
    //         setDataFetched(true)
    //     }
    // }, [vehicleRegdNo])

    // const handleClick = () => {
    //     window.open('', '_blank');
    // };

    const handleRegdNo = async (e) => {
        let regdNo = e.target.value;
        setVehicleRegdNo(e.target.value);
        if (regdNo.length === 9 || regdNo.length === 10) {

            const formData = {
                "regdNo": regdNo,
            }
            const vehicle = await dispatch(sendVehicleNumber(formData))
            const sendData = await dispatch(CaseActions.setVehicleInfo(vehicle.payload.response.result))
            setVehicleData(vehicle.payload.response.result);
            setDataFetched(true)
        }
    }
    const selectAssetType = [
        {
            id: 1,
            name: "Two Wheeler",
        },
        {
            id: 2,
            name: "Four Wheeler",
        },
        {
            id: 3,
            name: "Commercial",
        },
        {
            id: 4,
            name: "Construction Equipment",
        },
        {
            id: 5,
            name: "Three Wheeler",
        },
        {
            id: 6,
            name: "Farm Equipment",
        },
    ];

    const selectAssetTypeChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setAssetType(text);
    };

    const selectCaseType = [
        {
            id: 1,
            name: "Revaluation",
        },
        {
            id: 2,
            name: "Repossession",
        },
        {
            id: 3,
            name: "Retail",
        },
        {
            id: 4,
            name: "Insurance Idv",
        },
        {
            id: 5,
            name: "Repurchase",
        },
    ];
    const selectCaseChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setCaseType(text);
    };
    const handleCaseUpdate = async () => {
        if (dataFetched === true) {
            const formData = {
                assetType: assetType,
                caseType: caseType,
                valuationPurpose: valuationPurpose,
                requesterName: requesterName,
                requesterBranch: requesterBranch,
                requesterPhone: requesterPhone,
                name: name,
                mobile: mobileNo,
                email: email,
                address: address,
                city: city,
                state: state,
                vehicleLocation: vehicleLocation,
                regdNo: vehicleRegdNo,
                brand: make,
                model: model,
                variant: variant,
                vehicleEdetails: {
                    blacklistReason: vehicleData.blacklistReason,
                    blacklistStatus: vehicleData.blacklistStatus,
                    bodyType: vehicleData.bodyType,
                    chassis: vehicleData.chassis,
                    class: vehicleData.class,
                    engine: vehicleData.engine,
                    grossVehicleWeight: vehicleData.grossVehicleWeight,
                    isCommercial: vehicleData.isCommercial,
                    model: vehicleData.model,
                    normsType: vehicleData.normsType,
                    owner: vehicleData.owner,
                    ownerCount: vehicleData.ownerCount,
                    ownerFatherName: vehicleData.ownerFatherName,
                    permanentAddress: vehicleData.permanentAddress,
                    presentAddress: vehicleData.presentAddress,
                    rcExpiryDate: vehicleData.rcExpiryDate,
                    rcFinancer: vehicleData.rcFinancer,
                    rcStandardCap: vehicleData.rcStandardCap,
                    regAuthority: vehicleData.regAuthority,
                    regDate: vehicleData.regDate,
                    regNo: vehicleData.regNo,
                    status: vehicleData.status,
                    statusAsOn: vehicleData.statusAsOn,
                    type: vehicleData.type,
                    unladenWeight: vehicleData.unladenWeight,
                    vehicleCategory: vehicleData.vehicleCategory,
                    vehicleClass: vehicleData.vehicleClass,
                    vehicleColour: vehicleData.vehicleColour,
                    vehicleCubicCapacity: vehicleData.vehicleCubicCapacity,
                    vehicleCylindersNo: vehicleData.vehicleCylindersNo,
                    vehicleInsuranceCompanyName: vehicleData.vehicleInsuranceCompanyName,
                    vehicleInsurancePolicyNumber: vehicleData.vehicleInsurancePolicyNumber,
                    vehicleInsuranceUpto: vehicleData.vehicleInsuranceUpto,
                    vehicleManufacturerName: vehicleData.vehicleManufacturerName,
                    vehicleManufacturingMonthYear: vehicleData.vehicleManufacturingMonthYear,
                    vehicleNumber: vehicleData.vehicleNumber,
                    vehicleSeatCapacity: vehicleData.vehicleSeatCapacity,
                    vehicleTaxUpto: vehicleData.vehicleTaxUpto,
                    permitValidUpto: vehicleData.permitValidUpto,
                    permitType: vehicleData.permitType,
                    wheelbase: vehicleData.wheelbase,
                },
            };
            const config = {
                Headers: { 'Content-Type': 'application/json' },
            };
            const url = `${Baseurl}/api/v1/cases/updatecase/${params.id}`;
            const resp = await axios.put(url, formData, config);
            if (resp.data.success) {
                navigate(`/admin/editreport2/${params.id}`)
            }
        } else {
            alert("Please enter vehicle regd no again")
        }
    }

    return (
        <>
            <div className="min-h-screen flex flex-col lg:ps-64 w-full">
                <div className="p-6 space-y-6">
                    <div className="flex items-center justify-between w-full print:hidden">
                        <h4 className="text-lg font-semibold text-default-900">
                            Add Case Details
                        </h4>
                    </div>
                    <div className="shadow rounded-lg bg-white dark:bg-default-50 h-fit">
                        <div className="flex items-center justify-between py-4 px-5">
                            <h4 className="text-lg font-medium text-default-950 capitalize">
                                Add Case Details
                            </h4>
                        </div>
                        <div className="p-5 border-t border-dashed border-default-200">
                            <div className="grid md:grid-cols-2 gap-4">
                                <div className="space-y-1">
                                    <label
                                        htmlFor="twoWheelerBatteryCondtion"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Asset Type *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="twoWheelerBatteryCondtion"
                                        placeholder="This is a search placeholder"
                                        value={selectAssetType.id}
                                        name={selectAssetType.name}
                                        onChange={(e) => selectAssetTypeChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Asset Type
                                        </option>
                                        {selectAssetType.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === assetType}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fName"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Case Type *
                                    </label>
                                    <select
                                        className={
                                            `border-default-200 w-full`}
                                        data-trigger
                                        id="choices-single-default"
                                        placeholder="This is a search placeholder"
                                        value={selectCaseType.id}
                                        name={selectCaseType.name}
                                        onChange={(e) => selectCaseChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Case Type
                                        </option>
                                        {selectCaseType.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === caseType}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fValuation"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Valuation Purpose *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fValuation"
                                        placeholder="Enter Valuation Purpose"
                                        value={valuationPurpose}
                                        onChange={(e) => setValuationPurposeType(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fName"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Valuation Requested By *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            requesterNameError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fName"
                                        placeholder="Enter Requester Name"
                                        value={requesterName}
                                        onChange={(e) => setRequesterName(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fName"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Requester Branch Name *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            requesterBranchError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fName"
                                        placeholder="Enter Requester Branch"
                                        value={requesterBranch}
                                        onChange={(e) => setRequesterBranch(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="lName"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Requester Phone *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            requesterPhoneError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="lName"
                                        placeholder="Enter Requester Phone"
                                        minLength={10}
                                        maxLength={10}
                                        value={requesterPhone}
                                        onChange={(e) => handleRequesterPhn(e)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fName"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Customer Name *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fName"
                                        placeholder="Enter Name"
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fMobile"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Customer Mobile No *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fMobile"
                                        placeholder="Enter Mobile No"
                                        value={mobileNo}
                                        onChange={(e) => setMobileNo(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fEmail"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Customer Email *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fEmail"
                                        placeholder="Enter Email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fAddress"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Customer Address *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fAddress"
                                        placeholder="Enter Address"
                                        value={address}
                                        onChange={(e) => setAddress(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fState"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        State *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fState"
                                        placeholder="Enter State"
                                        value={state}
                                        onChange={(e) => setState(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fCity"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        City *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fCity"
                                        placeholder="Enter City"
                                        value={city}
                                        onChange={(e) => setCity(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fVehicleLocation"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Vehicle Location *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fVehicleLocation"
                                        placeholder="Enter Vehicle Location"
                                        value={vehicleLocation}
                                        onChange={(e) => setVehicleLocation(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fVehicleRegistration"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Vehicle Registration No *
                                    </label>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <input
                                            type="text"
                                            className={
                                                "block  rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                            }
                                            id="fVehicleRegistration"
                                            placeholder="Enter Vehicle Registration No"
                                            value={vehicleRegdNo}
                                            // onChange={(e) => setVehicleRegdNo(e.target.value)}
                                            onChange={(e) => handleRegdNo(e)}
                                        />
                                        {
                                            dataFetched && vehicleData ? (<>
                                                <a href="/vehicleinfo" target='_blank'>
                                                    <button style={{ backgroundColor: '#009900', color: '#fff', padding: '10px', borderRadius: '10px' }} target='_blank'>View Info</button>
                                                </a>
                                            </>) : (<></>)
                                        }
                                    </div>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fMake"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Make (Vehicle Brand)*
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fMake"
                                        placeholder="Enter Make"
                                        value={make}
                                        onChange={(e) => setMake(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fModel"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Model (Vehicle Model)*
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fModel"
                                        placeholder="Enter Model"
                                        value={model}
                                        onChange={(e) => setModel(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fVariant"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Variant (Vehicle Variant)*
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fVariant"
                                        placeholder="Enter Variant"
                                        value={variant}
                                        onChange={(e) => setVariant(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="flex items-center gap-2 justify-end" style={{ marginBottom: '80px' }}>
                        {/* <button
                            onClick={(e) => cancelClick(e)}
                            className="py-2 px-5 inline-flex items-center justify-center gap-2 font-semibold tracking-wide border border-transparent align-middle duration-500 text-sm text-center text-red-600 hover:border-red-500/20 hover:bg-red-500/20 rounded transition-all"
                        >
                            <i className="ph-bold ph-x text-lg" /> cancel
                        </button> */}
                        {
                            dataFetched && vehicleData ? (<>
                                <button
                                    className="py-2 px-5 inline-flex items-center justify-center gap-2 font-semibold tracking-wide border align-middle duration-500 text-sm text-center bg-default-800 hover:bg-default-950  text-default-50 rounded"
                                    style={{ background: "#8481ff", border: 'none', outline: 'none' }}
                                    onClick={() => handleCaseUpdate()}
                                >
                                    <i className="ph-duotone ph-cloud-arrow-up text-lg" />
                                    Next
                                </button>
                            </>) : (<></>)
                        }
                    </div>
                </div>
            </div >
        </>
    )
}

export default EditReport